export const bankInformation = {
    EXISTING: 'EXISTING',
    NEW: 'NEW',
};

export const bankInformationText = {
    [bankInformation.EXISTING]: 'Bestehende verwenden',
    [bankInformation.NEW]: 'Neue verwenden',
};
